import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { PapiCorePackage } from '@wix/da-papi-types';
import CoreMonthlyPriceAndCycle from '../../../../CoreMonthlyPriceAndCycle';
import { useTranslation } from 'react-i18next';

import s from './PackageLabel.scss';

interface Props {
  corePackage: PapiCorePackage;
  shouldPackageShowDiscount: boolean;
}

const PackageLabel: React.FC<Props> = ({
  corePackage,
  shouldPackageShowDiscount,
}) => {
  const { interval: cycle } = corePackage;
  const { t } = useTranslation();

  const isMobile = useContext(MobileContext);

  const cycleLabel =
    cycle === 'year'
      ? t('packagePicker.billingCycle.new.yearly')
      : t('packagePicker.billingCycle.new.monthly');

  return isMobile ? (
    <div className={s['cycle']}>{cycleLabel}</div>
  ) : (
    <div className={s['root']}>
      <div className={s['cycle']}>{cycleLabel}</div>
      <CoreMonthlyPriceAndCycle
        corePackage={corePackage}
        priceStyle="bold"
        shouldPackageShowDiscount={shouldPackageShowDiscount}
      />
    </div>
  );
};
PackageLabel.displayName = 'PackageLabel';

export default PackageLabel;
